var Aneox;(function (Aneox) {Aneox.Data = Aneox.Data || {};Aneox.Data.Data = {};})(Aneox || (Aneox = {}));